import {Component, Input, OnInit, Output, EventEmitter} from '@angular/core';
import {Information} from '../../../model/information';
import {DomSanitizer} from '@angular/platform-browser';
import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {BadgeComponent} from "../badge/badge.component";
import {NgbTooltip} from "@ng-bootstrap/ng-bootstrap";
import {CommonModule} from "@angular/common";
import {FilterCategoryWithPermPipe} from "../FilterCategoryWithPermPipe";

@Component({
    selector: 'app-info-block',
    templateUrl: './info-block.component.html',
    imports: [
        CommonModule,
        FaIconComponent,
        BadgeComponent,
        NgbTooltip,
        FilterCategoryWithPermPipe,
    ],
    styleUrls: ['./info-block.component.css']
})
export class InfoBlockComponent implements OnInit {

  @Input() info: Information;
  @Input() adminMode = false;
  @Input() isFirst = false;

  @Output() edit = new EventEmitter<any>();
  @Output() history = new EventEmitter<any>();
  @Output() archive = new EventEmitter<any>();
  @Output() publish = new EventEmitter<any>();

  html;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnInit(): void {
    this.html = this.sanitizer.bypassSecurityTrustHtml(this.info.description);
  }

  launchEdit(): void {
    this.edit.emit();
  }

}
